import { localStorage } from '@/utils/local-storage';
import base_config from './base_config';
import mqtt from 'mqtt';
import bus from '../bus';

let $bus: {
  emit: (arg0: string, arg1: any) => void;
} | null;
let mqtt_state: number; //0:未连接 1:已经 -1:错误
let sub_topic: any;
let client: mqtt.MqttClient | null;
const need_subscribe_list: Array<any> = [];
export default () => {
  console.log(client);
  console.log($bus);

  const init = () => {
    $bus = bus;
    mqtt_state = 0;
    sub_topic = {};
    const config = {
      host: '',
      client_type: '',
      username: '',
      password: '',
      host_timeout: false,
      is_login: false,
      clientId: '',
      ...base_config,
    };

    const { host, port, endpoint, ...options } = config.connection;
    const connectUrl = `ws://${host}:${port}${endpoint}`;
    client = mqtt.connect(connectUrl, options);
    client.on('connect', () => {
      console.log('mqtt connect');
      console.log('client connected:' + client?.connected);

      mqtt_state = 1;
      for (const topic in sub_topic) {
        client?.subscribe(topic, sub_topic[topic]);
      }
      $bus?.emit('mqtt_state', mqtt_state);
      if (need_subscribe_list.length > 0) {
        need_subscribe_list.map((item: any) => {
          channel_subscribe_event(item.channel, item.event_type);
        });
        need_subscribe_list.length = 0;
      }

      // client?.subscribe('foo', { qos: 0 }, (error: any) => {
      //   if (error) {
      //     console.log('Subscribe to topics error', error);
      //   }
      // });
      //#test publish:
      // client?.publish(
      //   'foo',
      //   '{ "fun": "$broadcast","event_type":"foo","data":"1" }',
      //   { qos: 0 },
      //   error => {
      //     if (error) {
      //       console.log('Publish error', error);
      //     }
      //   },
      // );
    });

    client.on('message', (topic: string, message: any) => {
      if (topic.indexOf('channel/') === 0) {
        const topic_arr = topic.split('/');

        $bus?.emit(topic_arr[3], JSON.parse(message));
      } else if (topic.indexOf('monitor') >= 0) {
        const topic_arr = topic.split('/');
        $bus?.emit(topic_arr[1], JSON.parse(message));
      } else {
        $bus?.emit(topic, JSON.parse(message));
      }
    });
    client.on('error', () => {
      console.log('client connected:' + client?.connected);
      mqtt_state = -1;
      $bus?.emit('mqtt_state', mqtt_state);
      setTimeout(() => {
        if (!client?.connected && !client?.reconnecting) {
          client?.reconnect();
        }
      }, 2000);
      // if (topic.indexOf('channel/') === 0) {
      //   const topic_arr = topic.split('/');
      // handle_event(topic_arr[3], JSON.parse(message));
      // } else if (topic.indexOf('group/') === 0) {
      // handle_event(topic, JSON.parse(message));
      // }
    });
  };
  // const handle_event = (event_type: any, object: any) => {
  // postMessage({ event_type: event_type, data: object, fun: '$broadcast' });
  // };
  /**
   * 初始化登录后,应该订阅的信息频道
   */
  // const init_subscribe = () => {};

  const channel_subscribe_event = (channel: string | number, event_type: string) => {
    const web_flag = process.env.VUE_APP_WEB_FLAG;
    const topic = 'channel/' + web_flag + '/' + channel + '/' + event_type;
    if (client && client.connected) {
      sub_topic[topic] = { qos: 1 };
      client.subscribe(topic, { qos: 1 });
      console.log(`subscribe event: ${channel}/${event_type}!`);
    } else {
      need_subscribe_list.push({ channel: channel, event_type: event_type });
    }
  };

  const channel_unsubscribe_event = (channel: string | number, event_type: string) => {
    const web_flag = process.env.VUE_APP_WEB_FLAG;
    if (client && client.connected) {
      const topic = 'channel/' + web_flag + '/' + channel + '/' + event_type;
      delete sub_topic[topic];
      client.unsubscribe(topic);
      console.log(`unsubscribe event: ${channel}/${event_type}!`);
    }
  };

  const liyudas_subscribe_event = (event_type: string) => {
    if (client && client.connected) {
      const topic = 'liyudas/datascript/' + event_type;
      sub_topic[topic] = { qos: 1 };
      client.subscribe(topic, { qos: 1 });
      console.log(`subscribe event: ${topic}!`);
    }
  };

  function liyudas_unsubscribe_event(event_type: string) {
    if (client && client.connected) {
      const topic = 'liyudas/datascript/' + event_type;
      delete sub_topic[topic];
      client.unsubscribe(topic);
      console.log(`unsubscribe event: ${topic}!`);
    }
  }
  // const is_mqttserver = () => {
  //   let mqtt_state;
  //   if (localStorage.get('mqtt_state')) {
  //     mqtt_state = parseInt(localStorage.get('mqtt_state'));
  //   }
  //   if (mqtt_state == undefined) {
  //     return 1;
  //   }
  //   return mqtt_state;
  // };
  const logout = () => {
    client?.end(true, {}, () => {
      mqtt_state = -1;
      $bus?.emit('mqtt_state', mqtt_state);
    });
  };
  return {
    init: init,
    // login: login,
    logout: logout,
    // init_subscribe: init_subscribe,
    // is_mqttserver: is_mqttserver,
    channel_subscribe_event: channel_subscribe_event,
    channel_unsubscribe_event: channel_unsubscribe_event,
    liyudas_subscribe_event: liyudas_subscribe_event,
    liyudas_unsubscribe_event: liyudas_unsubscribe_event,
  };
};
